/**
 * Creates a object for every .Users DOM element.
 */
common.View.create('website_users::admin.websiteUsers.CreateEdit', {

    onDOMLoad()
    {
        this.initResendMail();
    },

    initResendMail()
    {
        this.element.find('.resend-mail').click((event) => {
            // Prevent the default action of the button
            event.preventDefault();

            const button = $(event.currentTarget);

            // Retrieve Swal options
            const swalOptions = button.data('swal-options');

            Swal.fire({
                ...swalOptions,
                showCancelButton: true,
            }).then((result) => {
                if (result.isConfirmed) {
                    let prizeId = button.data('prize-card');
                    let actionUrl = button.data('action');

                    const email = result.value;

                    axios.post(actionUrl, {
                        _token: $('meta[name="csrf-token"]').attr('content'),
                        prizeId: prizeId,
                        email: email,
                    })
                        .then((response) => {
                            Swal.fire('Gelukt!', response.data.message, 'success');
                        })
                        .catch((error) => {
                            Swal.fire('Error', error.data.message, 'error');
                        });
                }
            });
        });
    }
});
